"use client";

//@ts-ignore
import "slick-carousel/slick/slick.css";
//@ts-ignore
import "slick-carousel/slick/slick-theme.css";

export default function SliderStyles() {
  return null;
}
